import { ApiResponse } from "../model/base"
import { AuthData, IGoogleLoginRes, ILoginEmailResponse, IUserInfo, UserResponse } from "../model/user"
import { getData, postData } from "../utils/HttpUtils"

export async function getUserInfo():Promise<UserResponse> {
  const res = await getData('/api/user/user_info', {scene: "solve"})
  return res
}

export async function getUserInfoVisior():Promise<AuthData> {
  const res = await postData('/api/user/login/visitor', {scene: "solve"}, true)
  return res
}

export async function sendVerifyCode(email: string):Promise<{}> {
  const res = await postData('/api/user/email/send_verify_code', {scene: "solve", email, language: 'en'})
  return res
}

export async function loginByVerifyCode(email: string, code: string ):Promise<ILoginEmailResponse> {
  const res = await postData('/api/user/login/email_code', {scene: "solve", email, code})
  return res
}

export async function sendGoogleIdToken(identity_token: string ): Promise<IGoogleLoginRes> {
  const res = await postData('/api/user/login/google', {scene: "solve", app_type: 'web', identity_token})
  return res
}
